export default "__VITE_ASSET__Co9evg7Y__"